import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Brandmark } from './Brandmark';
import { IconBell, IconHelp } from './icons';
import { labelForPath } from '../nav';
import { useAuth } from '../context/AuthContext';
import stageWebm from '../assets/login-stage.webm';
import stageMp4 from '../assets/login-stage.mp4';
import stagePoster from '../assets/login-stage-poster.jpg';

export function Topbar({ onHamburger }: { onHamburger: () => void }) {
  const { state, logout, isClientOwnerOnly } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();
  const title = isClientOwnerOnly ? 'Mon stock' : labelForPath(loc.pathname);

  // Même boucle vidéo que l'écran de connexion, en fond discret et continu
  // de la barre du haut (autoplay muette, ne s'arrête jamais).
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoReady, setVideoReady] = useState(false);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const markReady = () => setVideoReady(true);
    video.addEventListener('loadeddata', markReady);
    if (video.readyState >= 2) markReady();
    video.muted = true;
    video.defaultMuted = true;
    video.play().catch(() => { /* le poster reste visible, rien a faire */ });
    const onVisibility = () => {
      if (document.hidden) video.pause();
      else video.play().catch(() => {});
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      video.removeEventListener('loadeddata', markReady);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return (
    <div className="topbar">
      <video
        ref={videoRef}
        className={'topbar-media' + (videoReady ? ' is-ready' : '')}
        autoPlay
        muted
        loop
        playsInline
        poster={stagePoster}
        aria-hidden="true"
      >
        <source src={stageWebm} type="video/webm" />
        <source src={stageMp4} type="video/mp4" />
      </video>
      <div className="topbar-veil" />
      <div className="topbar-left">
        <button className="hamburger" onClick={onHamburger}>&#9776;</button>
        <Brandmark />
        <span className="topbar-title">{title}</span>
      </div>
      <div className="topbar-right">
        {!isClientOwnerOnly && (
          <button className="iconbtn" title="Alertes" onClick={() => navigate('alerts')}>
            <IconBell width={18} height={18} />
          </button>
        )}
        {isClientOwnerOnly && (
          <button className="iconbtn" title="Guide utilisateur" onClick={() => navigate('guide')}>
            <IconHelp width={18} height={18} />
          </button>
        )}
        <span className="topbar-who">{state.user} @ {state.tenant}</span>
        <button className="small" onClick={logout}>Déconnexion</button>
      </div>
    </div>
  );
}
